<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
    <path
      fill-rule="evenodd"
      d="M10 5.015L4.965 10 3.802 8.83l2.981-3.002H0V4.172h6.783l-2.98-3.001L4.964 0z"
    />
  </svg>
</template>

<script>
export default {
  name: 'ArrowRightIcon'
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

path {
  fill: $arrow-color;
}
</style>
